import Joi from 'joi';
import type { Revision } from '../configuration/configModel';
import { revisionSchema } from '../configuration/configModel';
import type { IConfigureParams } from './configureParams';
import { configureParamsSchemaMap } from './configureParams';
import { objectSchemaOf } from '../helpers';

export const initiateVoiceToTextParamsSchema = objectSchemaOf<IInitiateVoiceToTextParams>(
  {
    ...configureParamsSchemaMap,
    conversationId: Joi.string().required(),
    sampleRate: Joi.number().required(),
    consoleId: Joi.string().required(),
    organisationId: Joi.string().required(),
    shouldSendMessage: Joi.boolean().required(),
    immediateStart: Joi.boolean().required(),

    microphoneDescription: Joi.string().required(),
    consoleVersion: Joi.string().required(),
    configRevision: revisionSchema,

    disableRecording: Joi.boolean().optional(),
    script: Joi.string().optional(),
  }
);

export interface IInitiateVoiceToTextParams extends IConfigureParams {
  conversationId: string;
  sampleRate: number;
  consoleId: string;
  organisationId: string;
  shouldSendMessage: boolean;
  immediateStart: boolean;

  microphoneDescription: string;
  consoleVersion: string;
  configRevision: Revision;

  disableRecording?: boolean;
  script?: string;
}
